export class ApiConstants {
  public static readonly COUNT_HEADER = "x-total-count";
}
